/**
 * tenurePhase — utility for the "Explore the Colosseum" subtitle that
 * ages with the user. Owen Jul 2026 brief: the "first five days" copy
 * should morph as the user settles in.
 *
 * Phases:
 *   0–5   days  → first_five_days   "Things to do in your first five days"
 *   6–30  days  → first_month       "Things waiting for you this month"
 *   31–90 days  → first_quarter     "Places you haven't been yet"
 *   91–180      → first_half_year   "Return to what you started"
 *   181+        → long_time         "Rediscover your scroll"
 *
 * Consumers translate via `t(\`tenure_phase.${phaseKey}\`)`.
 */

export const TENURE_PHASE_KEYS = [
  'first_five_days',
  'first_month',
  'first_quarter',
  'first_half_year',
  'long_time',
];

export const tenurePhaseKey = (user) => {
  if (!user) return 'first_five_days';
  const createdRaw = user.created_at || user.createdAt || user.signup_at;
  if (!createdRaw) return 'first_five_days';
  const createdMs = new Date(createdRaw).getTime();
  if (!Number.isFinite(createdMs)) return 'first_five_days';
  const days = Math.max(0, (Date.now() - createdMs) / (1000 * 60 * 60 * 24));
  if (days <= 5) return 'first_five_days';
  if (days <= 30) return 'first_month';
  if (days <= 90) return 'first_quarter';
  if (days <= 180) return 'first_half_year';
  return 'long_time';
};
